export const WEBSITE_NAME = 'Mapant.fr';
export const FRANCE_CENTER = [656340.5199774752, 6604568.647570848];
export const TILE_SIZE_IN_METERS = 1000;
export const MAX_JOB_TIME_IN_SECONDS = 10 * 60;
